<template></template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "SubCategories",
    props: {
        categoryName: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['fetchSubCategories']),
        fetchSubCategoriesFxn(theCategoryName) {
            let subCategoryObj = {
                categoryName: theCategoryName
            }
            this.fetchSubCategories(subCategoryObj).then(() => {}).catch((e) => {})
        }
    },
    watch: {
        categoryName() {
            this.fetchSubCategoriesFxn(this.categoryName)
        }
    },
    created() {
        this.fetchSubCategoriesFxn(this.categoryName)
    }
}
</script>